import { createContext } from 'react';

const NivelUsuarioContext = createContext();

export default NivelUsuarioContext;
